import ApiGateway from '../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
const apiRef = 'SystemManagementApi';
const removeMobileDevice = async (input) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/MobileDevice/removeMobileDevice', input, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
const removeSNSEndpoint = async (input) => {
    let response = { err: null, data: null };
    try {
        response = await ApiGateway.post('/system/MobileDevice/removeSNSEndpoint', input, apiRef);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
/**
 * **Mobile Device DAO**
 */
export const MobileDeviceDAO = {
    removeMobileDevice,
    removeSNSEndpoint,
};
